<section class="talk-detail-page">

    @if (isLoading) {
      <div class="loading-state">
        <p>Cargando plática...</p>
      </div>
    }
  
    @if (!isLoading && talk) {
  
      <div class="talk-detail-header">
  
        <button
          type="button"
          class="back-button"
          (click)="goBack()"
        >
          ← Volver a pláticas
        </button>
  
        <div class="talk-title-section">
          <h1>{{ talk.name }}</h1>
  
          <p>
            📍 {{ talk.location || 'Sin ubicación' }}
          </p>
        </div>
  
      </div>
  
      <div class="talk-summary">
  
        <div class="summary-item">
          <span>Fecha</span>
  
          <strong>
            {{ talk.date | date:'mediumDate':'UTC' }}
          </strong>
        </div>
  
        <div class="summary-item">
          <span>Participantes</span>
  
          <strong>
            {{ talk.participants?.length || 0 }}
          </strong>
        </div>
  
        <div class="summary-item">
          <span>Encuesta de entrada</span>
  
          <strong>
            {{ talk.entrySurvey ? 'Sí' : 'No' }}
          </strong>
        </div>
  
        <div class="summary-item">
          <span>Encuesta de salida</span>
  
          <strong>
            {{ talk.exitSurvey ? 'Sí' : 'No' }}
          </strong>
        </div>
  
      </div>
  
      <div class="participants-section">
  
        <div class="section-header">
          <div>
            <h2>Participantes</h2>
  
            <p>
              Personas registradas en esta plática.
            </p>
          </div>
        </div>
  
        @if (!talk.participants?.length) {
          <div class="empty-participants">
            <p>
              Esta plática todavía no tiene participantes registrados.
            </p>
          </div>
        }
  
        @if (talk.participants?.length) {
  
          <div class="participants-list">
  
            @for (
              participant of talk.participants;
              track $index
            ) {
  
              <article class="participant-card">
  
                <div class="participant-main">
                  <h3>
                    {{ participant.name }}
                  </h3>
  
                  <span>
                    {{ participant.email || 'Sin correo registrado' }}
                  </span>

                  @if (participant.interactionFolio) {
                    <!-- C3.3: folio de oportunidad (OP-TLK-...) por asistente -->
                    <div class="participant-folio">
                      <app-folio-pill
                        [folio]="participant.interactionFolio"
                        [interactionType]="'OP'"
                        [showHours]="false"
                      ></app-folio-pill>
                    </div>
                  }
                </div>
  
                <div class="participant-info">
  
                  <div>
                    <span>Sexo</span>
                    <strong>
                      {{ participant.sex || '—' }}
                    </strong>
                  </div>
  
                  <div>
                    <span>Edad</span>
                    <strong>
                      {{ participant.age ?? '—' }}
                    </strong>
                  </div>
  
                  <div>
                    <span>Teléfono</span>
                    <strong>
                      {{ participant.phone || '—' }}
                    </strong>
                  </div>
  
                </div>
  
                @if (participant.followUp) {
                  <div class="participant-follow-up">
                    <span>Seguimiento</span>
  
                    <p>
                      {{ participant.followUp }}
                    </p>
                  </div>
                }
  
              </article>
  
            }
  
          </div>
  
        }
  
      </div>
  
    }
  
    @if (!isLoading && !talk) {
      <div class="empty-state">
        <p>No se pudo encontrar la plática.</p>
  
        <button
          type="button"
          class="back-button"
          (click)="goBack()"
        >
          Volver a pláticas
        </button>
      </div>
    }
  
  </section>